import { Redirect, Router } from 'aurelia-router';
import { computedFrom, autoinject, Aurelia } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';
import { RegistrationController } from '../../controllers/registration-controller'
import { DefaultValidationRenderer } from "../../resources/renderers/default-validation-renderer";
import { PageMessageService } from "../../services/page-message-service";
import { BusyService } from "../../services/busy-service";
import { Carrier } from "../../models/carrier";
import { SelectLocationsDialog } from "../../public/register/select-locations-dialog";
import { AppMessageService } from "../../services/app-message-service";

@autoinject
export class CarrierInfo {

    constructor(private router: Router,
        public reg: RegistrationController,
        private controllerFactory: ValidationControllerFactory,
        private pageMessageService: PageMessageService,
        private appMessageService: AppMessageService,
        private dialogService: DialogService,
        private busyService: BusyService,
        private aurelia: Aurelia
    ) {
        this.controller = controllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.change;
        this.controller.addRenderer(new DefaultValidationRenderer());
    }
    controller: ValidationController = null;
    equipmentTypes: Array<any> = [];
    equipmentGroups: Array<any> = [];
    heavyHaulerWeights: Array<any> = [];


    canActivate(params): any {
        ////enable this page as entry point for debugging (only for local environment)
        // if ((<any>this.aurelia.host.attributes).environment.value.toLowerCase() == "local") {
        //     if (!this.reg.carrier) {
        //         this.reg.carrier = new Carrier();
        //         this.reg.carrier.legalName = "DYNAMITE DOCUMENT DESTRUCTION";
        //         this.reg.carrier.dotNumber = "1232032";
        //     }
        //  }
 
        if (!this.reg.carrier) {
            return new Redirect("registration/begin?id=" + params.id);
        } else {
            return !this.reg.carrier.isSubmitted;
        }
    }

    activate() {

        this.loadEquipmentTypes();
        this.loadHeavyHaulerWeights();

    }

    loadHeavyHaulerWeights() {
        this.busyService.on();
        this.reg.getHeavyHaulerWeights()
            .then((result) => {
                this.heavyHaulerWeights = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    attached() {
        (<any>$(".diversity-info-button,.hazmat-info-button")).popover();
    }


    @computedFrom("reg.carrier.hasTrucks", "this.equipmentTypes.length")
    get filteredEquipmentTypes() {
        const eqtypes = this.equipmentTypes.filter(o => {
            // for non-trucks, only show transloader equipment.
            if (!this.reg.carrier.hasTrucks) {
                if (o.equipmentTypeId != 'e3e2990e-c080-4997-9c4e-bfc656095c2f') {
                    return false;
                }
            }
            return true;
        });

        this.calculateEquipmentGroups(eqtypes);

        return eqtypes;
    }

    
    public diversityCategories = [
        {name: "Minority Owned", value: "87eb5c19-cf2d-4b0f-a2a4-8d246251e95e"},
        {name: "Woman Owned", value: "99d55403-4eef-4e80-ba5d-f8c6831d92a6"},
        {name: "Veteran Owned", value: "83624890-38e7-44d1-b1d8-be6446324cc9"}
    ]

    private calculateEquipmentGroups(equipmentTypes: any[]) {
        const newEquipmentGroups = [];
        equipmentTypes.forEach(o => {
            if (newEquipmentGroups.indexOf(o.type) == -1) {
                newEquipmentGroups.push(o.type);
            }
        });
        if (JSON.stringify(this.equipmentGroups) != JSON.stringify(newEquipmentGroups)) {
            this.equipmentGroups = newEquipmentGroups;
        }
    }

    loadEquipmentTypes() {
        this.busyService.on();
        this.reg.getEquipment()
            .then((result) => {
                this.equipmentTypes = JSON.parse(result.response);
                this.calculateEquipmentGroups(this.filteredEquipmentTypes);
            })
            .finally(() => this.busyService.off());
    }

    //animate height using css3
    //  http://stackoverflow.com/a/9763697/91189
    removeLocation(division, event) {
        var index = this.reg.carrier.existingCarrierDivisions.indexOf(division);
        if (index > -1) {
            this.reg.carrier.existingCarrierDivisions.splice(index, 1);
        }
    }

    selectLocations() {
        this.dialogService.open(
            {
                viewModel: SelectLocationsDialog,
                model: this.reg.carrier.existingCarrierDivisions
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    this.reg.carrier.existingCarrierDivisions = result.output;
                }
                else {
                }
            });
    }

    submit() {
        this.appMessageService.clearPageScopedMessages();
        this.pageMessageService.clear();
        this.controller.validate().then(v => {
            if (v.length === 0) {
                this.busyService.on();
                this.reg.submitRegistration()
                    .then(() => {
                        this.router.navigate("complete");
                    })
                    .catch((error) => {
                        //alert(JSON.stringify(error));
                    })
                    .finally(() => {
                        this.busyService.off();
                    });
            }
            else {
                this.pageMessageService.setDefaultValidationMessage();
            }
        });
    }
}
